import React from 'react';
import {Heading, type HeadingProps} from '@tempo/core';

const Title: React.FC<HeadingProps> = ({children, ...props}) => (
	<Heading
		variant="heading.l"
		mb="spacing.l"
		mt="spacing.xl"
		as="h2"
		color="text.neutral.primary.default"
		{...props}
	>
		{children}
	</Heading>
);

export default Title;
